import { useEffect, useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  INSTALLATION_DETAIL_STALE_KEY,
  resolveAddressFromSources,
} from "./installation/installationConfigUtils";
import AppHeaderBar from "./AppHeaderBar";
import AppNavBar from "./AppNavBar";
import { getShortIdPart } from "../components/formatted/FormattedText";
import { useTranslation } from "react-i18next";
import { useInstallationCamera } from "./installation/useInstallationCamera";
import InstallationConfigPanel from "./installation/InstallationConfigPanel";
import InstallationDetailHero from "./installation/InstallationDetailHero";
import InstallationVisualizationSection from "./installation/InstallationVisualizationSection";

const AppInstallationDetails = ({ setCookies, saveUser }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const location = useLocation();
  const cameraListItem = location.state?.cameraListItem;
  const {
    loading,
    error,
    leftCamera,
    rightCamera,
    hasRightCamera,
    configData,
    setConfigData,
    cycleEntries,
    batteryLevel,
    networkDetails,
    simProvider,
    siteEditId,
    reload,
    api,
    token,
  } = useInstallationCamera(id, cameraListItem);

  useEffect(() => {
    if (!sessionStorage.getItem(INSTALLATION_DETAIL_STALE_KEY)) {
      return;
    }
    sessionStorage.removeItem(INSTALLATION_DETAIL_STALE_KEY);
    void reload({ silent: true });
  }, [location.pathname, reload]);

  const sensorIdLabel = `ak_${getShortIdPart(id)}`;
  const heroAddress = useMemo(() => {
    return resolveAddressFromSources(leftCamera, cameraListItem).addressName;
  }, [leftCamera, cameraListItem]);

  const heroStatus = leftCamera?.status || cameraListItem?.status;

  return (
    <div className="installation-detail-page">
      <AppHeaderBar
        title={t("Installation")}
        setCookies={setCookies}
        saveUser={saveUser}
      />
      <div className="installation-detail-shell">
        <InstallationDetailHero
          sensorIdLabel={sensorIdLabel}
          addressName={heroAddress}
          status={heroStatus}
          onBackToList={() => history.push("/app/installation")}
        />

        <div className="installation-detail-content">
          {loading && !leftCamera && (
            <div className="installation-detail-state">
              <div className="installation-detail-spinner" aria-hidden />
              <p>{t("installation_loading")}</p>
            </div>
          )}
          {error && !leftCamera && (
            <div className="installation-detail-state installation-detail-state-error">
              <p>{t("installation_load_error")}</p>
            </div>
          )}
          {leftCamera && (
            <>
              <InstallationVisualizationSection
                variant="prominent"
                routeCameraId={id}
                cycleEntries={cycleEntries}
              />
              <InstallationConfigPanel
                api={api}
                token={token}
                routeCameraId={id}
                leftCamera={leftCamera}
                rightCamera={rightCamera}
                hasRightCamera={hasRightCamera}
                configData={configData}
                setConfigData={setConfigData}
                siteEditId={siteEditId}
                cameraListItem={cameraListItem}
                reload={reload}
                batteryLevel={batteryLevel}
                networkDetails={networkDetails}
                simProvider={simProvider}
                batteryLoading={loading && !leftCamera}
              />
            </>
          )}
        </div>
      </div>
      <AppNavBar />
    </div>
  );
};

export default AppInstallationDetails;
